<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            Australia - COVID-19 Data Dashboard:
          </h4>
          <Breadcrumbs
            :breadcrumbs="[
              { title: 'Dashboards', to: `/dashboard` },
              { title: 'Australian Dashboard', to: '/dashboards/australia' }
            ]"
          />

          <p class="mt-2">
            Data sourced from Johns Hopkins global cases tracking centre. Data
            updated every 15 minutes.
          </p>
          <p>
            For more information on how this data is collected and maintained,
            please see the
            <a href="https://coronavirus.jhu.edu/" target="_blank"
              >Johns Hopkins Coronavirus Resource Centre</a
            >
          </p>
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 "
      >
        <vx-card title="Australian Active Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.activeCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Australian New Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.newCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Australian Total Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.totalCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Australian Critical Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.criticalCases"
            :loading="loading"
          />
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card title="Australian Recovered Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.recoveredCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Australian New Deaths:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.newDeaths"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Australian Total Deaths:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.totalDeaths"
            :loading="loading"
          />
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card title="Australian Total Tests:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentAustralianLiveData.dataSets.totalAusTest]"
            :loading="!australianLiveDataLoaded"
          />
        </vx-card>
        <vx-card title="Australian Total Hospitalisations:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentAustralianLiveData.dataSets.totalAusHospital]"
            :loading="!australianLiveDataLoaded"
          />
        </vx-card>
        <vx-card title="Australian Total ICU:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentAustralianLiveData.dataSets.totalAusIcu]"
            :loading="!australianLiveDataLoaded"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import ActiveCasesCard from "@/modules/dashboard/components/dashboard-cards/ActiveCasesCard";
import NewCasesCard from "@/modules/dashboard/components/dashboard-cards/NewCasesCard";
import TotalCasesCard from "@/modules/dashboard/components/dashboard-cards/TotalCasesCard";
import CriticalCasesCard from "@/modules/dashboard/components/dashboard-cards/CriticalCasesCard";
import RecoveredCasesCard from "@/modules/dashboard/components/dashboard-cards/RecoveredCasesCard";
import NewDeathsCard from "@/modules/dashboard/components/dashboard-cards/NewDeathsCard";
import TotalDeathsCard from "@/modules/dashboard/components/dashboard-cards/TotalDeathsCard";
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import { getAustralianData } from "@/modules/dashboard/utilities/australianStatisticsCalculator";
import GraphTile from "@/modules/dashboard/components/dashboard-cards/GraphTile";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "AustraliaDashboard",
  components: {
    ActiveCasesCard,
    NewCasesCard,
    TotalCasesCard,
    CriticalCasesCard,
    RecoveredCasesCard,
    NewDeathsCard,
    TotalDeathsCard,
    Breadcrumbs,
    GraphTile
  },
  data() {
    return {
      dateRange: [],
      dataSets: {},
      loading: true
    };
  },
  computed: {
    ...mapState(["australianLiveData", "australianLiveDataLoaded"]),
    componentAustralianLiveData() {
      return _.cloneDeep(this.australianLiveData);
    },
    reversedDateRange() {
      let clonedDateRange = _.cloneDeep(
        this.componentAustralianLiveData.dateRange
      );

      return clonedDateRange;
    }
  },
  mounted() {
    getAustralianData()
      .then(australianData => {
        this.dateRange = australianData.dateRange;
        this.dataSets.activeCases = [australianData.dataSets.activeCaseData];
        this.dataSets.newCases = [australianData.dataSets.newCaseData];
        this.dataSets.totalCases = [australianData.dataSets.totalCaseData];
        this.dataSets.criticalCases = [
          australianData.dataSets.criticalCaseData
        ];
        this.dataSets.recoveredCases = [
          australianData.dataSets.recoveredCaseData
        ];
        this.dataSets.newDeaths = [australianData.dataSets.newDeathData];
        this.dataSets.totalDeaths = [australianData.dataSets.totalDeathData];
        this.loading = false;
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.breadcrumb {
  color: #7367f0;
}
</style>
